<template>
    <div>
        <lable>腸内細菌叢</lable>
    </div>
</template>
<script>
export default {
    
}
</script>